import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Container, Row, Col, Card, CardBody, Spinner } from 'reactstrap'
import DayGrid from '../../../components/Template/Calendar/DayGrid'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import { getAllMyPlannerTasks } from '../../../store/ducks/tasks'

class MyTasks extends Component {
  componentDidMount() {
    const { getAllMyPlannerTasks } = this.props

    getAllMyPlannerTasks()
  }

  render() {
    const { myPlannerTasks, getAllMyPlannerTasksIsLoading } = this.props.tasks

    if (getAllMyPlannerTasksIsLoading) {
      return (
        <div className="centered">
          <Spinner />
        </div>
      )
    }

    if (!getAllMyPlannerTasksIsLoading && myPlannerTasks) {
      return (
        <div className="page-content">
          <Container fluid>

            <Breadcrumbs
              title="Tarefas"
              breadcrumbItems={[]}
            />

            <Row className="mb-3">
              <Col>
                <h4>
                  Calendário
                </h4>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <DayGrid
                      events={myPlannerTasks.map((task, index) => ({
                        editable: false,
                        id: index,
                        title: task.title,
                        allDay: true,
                        start: task.completedDateTime || task.dueDateTime,
                        end: task.completedDateTime || task.dueDateTime,
                        backgroundColor: task.completedDateTime ? '#DBEBC7' : '#dee7ec',
                        borderColor: task.completedDateTime ? '#DBEBC7' : '#dee7ec',
                        textColor: '#1a1a1a',
                        done: !!task.completedDateTime,
                      }))}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>

          </Container>
        </div>
      )
    }

    return null
  }
}

const mapStateToProps = state => ({ tasks: state.tasks })
const mapDispatchToProps = dispatch => bindActionCreators({ getAllMyPlannerTasks }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(MyTasks)
